import { CHANNEL_TALK_URL } from '../../constant/url';

export const openChannelTalk = () => {
  window.open(CHANNEL_TALK_URL);
};
